import {
    INVALIDATE_IMPERSONATION_SUCCESS,
    INVALIDATE_IMPERSONATION_FAILURE,
} from '../actions';

const initialState = {
    impersonationKey: '',
    statusCode: '0',
    statusMessage: '',
    invalidImpersonationError: false,
};

const invalidateImpersonationReducer = (state = initialState, action) => {
    switch (action.type) {
        case INVALIDATE_IMPERSONATION_SUCCESS:
            return {
                ...state,
                statusMessage: action.data.statusMessage,
                statusCode: action.data.statusCode,
            };
        case INVALIDATE_IMPERSONATION_FAILURE:
            return {
                ...state,
                invalidImpersonationError: true,
            };
        default: {
            return { ...state };
        }
    }
};

export default invalidateImpersonationReducer;
